import { render, staticRenderFns } from "./AutomationNewCardOption.vue?vue&type=template&id=33e00e7c&"
import script from "./AutomationNewCardOption.vue?vue&type=script&lang=js&"
export * from "./AutomationNewCardOption.vue?vue&type=script&lang=js&"
import style0 from "./AutomationNewCardOption.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports